/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeizableIncomeExplanationKind } from './SeizableIncomeExplanationKind';
import {
    SeizableIncomeExplanationKindFromJSON,
    SeizableIncomeExplanationKindFromJSONTyped,
    SeizableIncomeExplanationKindToJSON,
    SeizableIncomeExplanationKindToJSONTyped,
} from './SeizableIncomeExplanationKind';

/**
 * 
 * @export
 * @interface SeizableIncomeExplanationLineResponse
 */
export interface SeizableIncomeExplanationLineResponse {
    /**
     * 
     * @type {SeizableIncomeExplanationKind}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    kind: SeizableIncomeExplanationKind;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    paymentsPerYear: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    income: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    seizableAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    maintenanceObligationCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    otherIncome: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    share: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    subsistenceAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    baseAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    percentage: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeExplanationLineResponse
     */
    difference: number | null;
}



/**
 * Check if a given object implements the SeizableIncomeExplanationLineResponse interface.
 */
export function instanceOfSeizableIncomeExplanationLineResponse(value: object): value is SeizableIncomeExplanationLineResponse {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('paymentsPerYear' in value) || value['paymentsPerYear'] === undefined) return false;
    if (!('income' in value) || value['income'] === undefined) return false;
    if (!('seizableAmount' in value) || value['seizableAmount'] === undefined) return false;
    if (!('maintenanceObligationCount' in value) || value['maintenanceObligationCount'] === undefined) return false;
    if (!('otherIncome' in value) || value['otherIncome'] === undefined) return false;
    if (!('share' in value) || value['share'] === undefined) return false;
    if (!('subsistenceAmount' in value) || value['subsistenceAmount'] === undefined) return false;
    if (!('baseAmount' in value) || value['baseAmount'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    if (!('difference' in value) || value['difference'] === undefined) return false;
    return true;
}

export function SeizableIncomeExplanationLineResponseFromJSON(json: any): SeizableIncomeExplanationLineResponse {
    return SeizableIncomeExplanationLineResponseFromJSONTyped(json, false);
}

export function SeizableIncomeExplanationLineResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeizableIncomeExplanationLineResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': SeizableIncomeExplanationKindFromJSON(json['kind']),
        'paymentsPerYear': json['paymentsPerYear'],
        'income': json['income'],
        'seizableAmount': json['seizableAmount'],
        'maintenanceObligationCount': json['maintenanceObligationCount'],
        'otherIncome': json['otherIncome'],
        'share': json['share'],
        'subsistenceAmount': json['subsistenceAmount'],
        'baseAmount': json['baseAmount'],
        'percentage': json['percentage'],
        'difference': json['difference'],
    };
}

export function SeizableIncomeExplanationLineResponseToJSON(json: any): SeizableIncomeExplanationLineResponse {
    return SeizableIncomeExplanationLineResponseToJSONTyped(json, false);
}

export function SeizableIncomeExplanationLineResponseToJSONTyped(value?: SeizableIncomeExplanationLineResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': SeizableIncomeExplanationKindToJSON(value['kind']),
        'paymentsPerYear': value['paymentsPerYear'],
        'income': value['income'],
        'seizableAmount': value['seizableAmount'],
        'maintenanceObligationCount': value['maintenanceObligationCount'],
        'otherIncome': value['otherIncome'],
        'share': value['share'],
        'subsistenceAmount': value['subsistenceAmount'],
        'baseAmount': value['baseAmount'],
        'percentage': value['percentage'],
        'difference': value['difference'],
    };
}

